<template>
  <DropdownItemView :has-link="!!linkTo" :disabled="disabled">
    <router-link v-if="linkTo" :to="linkTo">
      <DropdownItemContent :icon="icon" :icon-classes="iconClasses" :label="label">
        <template #icon>
          <slot name="icon" />
        </template>
      </DropdownItemContent>
    </router-link>
    <section v-else @click="onClick" :data-e2e="AppCypressAttribute.buttons.DROPDOWN_ITEM">
      <DropdownItemContent :icon="icon" :icon-classes="iconClasses" :label="label">
        <template #icon>
          <slot name="icon" />
        </template>
      </DropdownItemContent>
    </section>
  </DropdownItemView>
</template>

<script>
import DropdownItemContent from '/@/modules/core/app/components/DropdownItemContent.vue';
import { AppCypressAttribute } from '@/modules/core/app/constants/AppCypressAttribute';
import DropdownItemView from '@/modules/core/ui/components/wrappers/DropdownItemView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DropdownItem',
  slotsDefinition: {
    icon: {}
  },
  components: { DropdownItemContent, DropdownItemView },
  props: {
    clickFn: { type: Function },
    fnParam: [String, Object, Number],
    linkTo: { type: Object, default: null },
    label: { type: String, required: true },
    icon: { type: String },
    hasLink: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    iconClasses: { type: String, default: '' },
    allowPropagation: { type: Boolean, default: false }
  },
  static: {
    AppCypressAttribute
  },
  methods: {
    onClick(event) {
      if (!this.allowPropagation) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.clickFn?.(this.fnParam);
    }
  }
};
</script>

<style scoped>
:deep(a.dropdown-item) {
  color: var(--ce-grey-darker) !important;
}
</style>
